import { createContext, useMemo } from 'react';

import useCollectionDataFetch from '@client/helpers/firebase/firestore/useFirestoreCollectionFetch';

import { getCollectionRef } from '@app/frontend/lib/firebase';

import { type StoredTransaction } from '@app/lib/firebase/types';

import { useAuth } from '../auth/AuthContext';

type TransactionContextType = {
  unreconciledTransactionCount: number;
};

const TransactionContext = createContext<TransactionContextType>({
  unreconciledTransactionCount: 0,
});

export const TransactionProvider = ({ children }: { children: React.ReactNode }) => {
  const { user } = useAuth();

  const collectionRef = useMemo(
    () => getCollectionRef<StoredTransaction & { id: string }>(`users/${user?.uid}/transactions`),
    [user?.uid],
  );

  const { data } = useCollectionDataFetch(collectionRef);

  const unreconciledTransactionCount = data.filter(
    transaction =>
      transaction.status !== 'matchingDone' &&
      transaction.status !== 'closingDone' &&
      transaction.status !== 'reconciliationDone',
  ).length;

  return (
    <TransactionContext.Provider value={{ unreconciledTransactionCount }}>
      {children}
    </TransactionContext.Provider>
  );
};

export default TransactionContext;
